import { render, staticRenderFns } from "./UniversityCard.vue?vue&type=template&id=8390bd40&scoped=true"
import script from "./UniversityCard.vue?vue&type=script&lang=ts"
export * from "./UniversityCard.vue?vue&type=script&lang=ts"
import style0 from "./UniversityCard.vue?vue&type=style&index=0&id=8390bd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8390bd40",
  null
  
)

export default component.exports